import { Checkbox } from "@mantine/core";
import dayjs from "dayjs";
import { useCallback, useEffect, useMemo } from "react";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useTheme } from "../../../../../hooks";
import { type ISummaryItem } from "../../../../../pages/Summary/Summary.types";
import { Flex, PaddingTd, StyledTr } from "../../../../../styled";
import StatusCell from "../../ReviewsTable/SummaryItemRow/Cells/StatusCell/StatusCell";
import { type IEntrySelectValue } from "../Multiple.model";
import { useShowContent } from "../../../../../generator/hooks/useShowContent";
import EntrySectionsRenderer from "./EntrySectionsRenderer";
import { DateTimeDisp } from "src/components/shared/DateTime";

interface Props extends ISummaryItem {
  setSelectedEntries: (selectedEntries: IEntrySelectValue[]) => void;
  selectedEntries: IEntrySelectValue[];
  isFocused: boolean;
  setFocused: (index: number) => void;
  sections?: Record<string, any>[];
  index: number;
  collapsed?: boolean;
  toggleCollapse?: (index: number) => void;
}

const EntriesSelectListItem = ({
  setSelectedEntries,
  selectedEntries,
  isFocused,
  setFocused,
  index,
  sections,
  collapsed,
  toggleCollapse,
  ...row
}: Props) => {
  const theme = useTheme() as any;

  const type = useMemo(
    () =>
      row.meid
        ? "meid"
        : row.partid
          ? "partid"
          : row.weid
            ? "weid"
            : row.lbeid
              ? "lbeid"
              : "",
    [row],
  );

  const selectValue: IEntrySelectValue = useMemo(
    () => ({
      idType: type,
      id: (row[type as keyof typeof row] ?? "") as string,
    }),
    [row, type],
  );
  const isChecked = useMemo(
    () => selectedEntries.some(el => el.id === selectValue.id),
    [selectedEntries, selectValue],
  );

  const { shouldHideElement } = useShowContent();

  const handleChange = useCallback(
    (indexToFocus: number) => {
      // setFocused(indexToFocus);
      if (isChecked) {
        setSelectedEntries(
          selectedEntries.filter(
            selectedEntry => selectedEntry.id !== selectValue.id,
          ),
        );
      } else {
        // if (selectedEntries.length > 14) {
        //   Notification(
        //     "Error",
        //     "You can only select up to 15 entries at once",
        //     "red",
        //   );
        //   return;
        // }
        setSelectedEntries([...selectedEntries, selectValue]);
      }
    },
    [selectValue, setSelectedEntries, selectedEntries, isChecked, setFocused],
  );

  // useEffect(() => {
  //   const handleKeyDown = (event: KeyboardEvent) => {
  //     if (event.key === "Enter" && isFocused) {
  //       // if (lastArrowKey !== "ArrowUp") handleChange(index + 1);
  //       // else handleChange(index);
  //       handleChange(index + 1);
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [isFocused, handleChange]);

  return (
    <>
      <StyledTr
        key={selectValue.id}
        style={{
          backgroundColor: isFocused
            ? theme.colors.main[4]
            : isChecked
              ? theme.colors.main[2]
              : "auto",
          cursor: "pointer",
        }}>
        {sections && (
          <PaddingTd
            style={{ width: 120 }}
            onClick={() =>
              sections && sections?.length > 0 && toggleCollapse?.(index)
            }>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {sections && sections?.length > 0 ? (
                collapsed ? (
                  <IconChevronDown />
                ) : (
                  <IconChevronUp />
                )
              ) : (
                "No Entry"
              )}
            </div>
          </PaddingTd>
        )}
        <PaddingTd onClick={() => handleChange(index)}>
          {row.colname ? <p>{row.colname}</p> : row.lbname}
        </PaddingTd>

        <PaddingTd onClick={() => handleChange(index)}>
          <DateTimeDisp
            dir="row"
            utc={row.datecreatedUTC ?? ""}
            lt={row.datecreated ?? ""}
          />
        </PaddingTd>
        <StatusCell
          onClick={() => handleChange(index)}
          singleCell
          review={row}
        />
        <PaddingTd onClick={() => handleChange(index)}>
          <Flex justify="center" align="center">
            <Checkbox
              styles={{ icon: { zIndex: 0 }, input: { cursor: "pointer" } }}
              defaultChecked={isChecked}
            />
          </Flex>
        </PaddingTd>
      </StyledTr>
      {sections && sections.length > 0 && !collapsed && (
        <StyledTr>
          <PaddingTd colSpan={5}>
            <div>
              <EntrySectionsRenderer
                key={index}
                sections={sections}
                id={(row[type as keyof typeof row] as string) ?? ""}
                entryIndex={index}
                shouldHideElement={shouldHideElement}
                headerOffset={36}
              />
            </div>
          </PaddingTd>
        </StyledTr>
      )}
    </>
  );
};
export default EntriesSelectListItem;
